import { ShaderMaterial as BABYLON_ShaderMaterial } from '@inter-ikea-betrakta-babylonjs/core/Materials/shaderMaterial.js';
import { Constants as BABYLON_Constants } from '@inter-ikea-betrakta-babylonjs/core/Engines/constants.js';
import '../shaders/ui_mesh.vertex.js';
import '../shaders/ui_mesh.fragment.js';
import { Framebuffer } from '../Framebuffer.js';
export const ALBEDO_ALPHA_INSTANCE_ATTRIBUTE_NAME = 'viewer_albedo_alpha_attribute';
export class ViewerUiMeshMaterial extends BABYLON_ShaderMaterial {
    constructor(_viewer) {
        super('UiMesh material', _viewer.scene, 'ui_mesh', {
            attributes: ['position', 'color', ALBEDO_ALPHA_INSTANCE_ATTRIBUTE_NAME],
            uniforms: ['viewProjection'],
            needAlphaBlending: true,
            needAlphaTesting: true,
            defines: _viewer.is_rendering_to_float_framebuffer() ? ['#define ENABLE_VIEWER_TONEMAPPING_IN_POST'] : []
        });
        this._viewer = _viewer;
        this.alphaMode = BABYLON_Constants.ALPHA_COMBINE;
        this.transparencyMode = BABYLON_ShaderMaterial.MATERIAL_ALPHABLEND;
        this.depthFunction = BABYLON_Constants.LEQUAL;
        this.backFaceCulling = true;
        this.cullBackFaces = false;
        this.forceDepthWrite = true;
        const gl = this._viewer.engine._gl;
        this.stencil.enabled = true;
        this.stencil.mask = Framebuffer.STENCIL_BLOCK_BLOOM_MASK;
        this.stencil.funcRef = Framebuffer.STENCIL_BLOCK_BLOOM_MASK;
        this.stencil.funcMask = Framebuffer.STENCIL_BLOCK_BLOOM_MASK;
        this.stencil.opStencilDepthPass = gl.REPLACE;
        this.stencil.opDepthFail = gl.KEEP;
        this.stencil.opStencilFail = gl.KEEP;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _afterBind(mesh, effect = null) {
        super._afterBind(mesh, effect);
        effect === null || effect === void 0 ? void 0 : effect.setMatrix('viewProjection', this.getScene().getTransformMatrix());
    }
}
//# sourceMappingURL=ViewerUiMeshMaterial.js.map